import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EventBookingBasic } from '../../../data-services/models/event-bookings/event-booking-basic.model';
import { EventBookingDetailed } from '../../../data-services/models/event-bookings/event-booking-detailed.model';
import { RouterModule } from '@angular/router';
import { EventBookingComplete } from '../../../data-services/models/event-bookings/event-booking-complete.model';

@Component({
  selector: 'app-event-booking-tile',
  imports: [FontAwesomeModule, DatePipe,RouterModule],
  templateUrl: '../ui/event-booking-tile.component.html',
  styleUrl: '../ui/event-booking-tile.component.css',
})
export class EventBookingTileComponent {
  @Input({ required: true}) booking!: EventBookingComplete
  @Input() includeLink: boolean = true;

  get hasPlayerTicket(): boolean {
    return this.booking.eventTickets.some(x => x.ticketType === 'Player' || x.ticketType === 'Player (Under 16)')
  }

  get hasCrewTicket(): boolean {
    return this.booking.eventTickets.some(x => x.ticketType === 'Crew' || x.ticketType === 'Crew (Under 16)')
  }

  get hasMealTicket(): boolean {
    return this.booking.eventTickets.some(x => x.ticketType === 'Meal' || x.ticketType === 'Meal (Under 16)')
  }

  get hasStaffTicket(): boolean {
    return this.booking.eventTickets.some(x => x.ticketType === 'Staff')
  }

  get hasOptionalTicket(): boolean {
    return this.booking.eventTickets.some(x => x.ticketType === 'Optional')
  }
}
